import { AppServices } from 'network'
import { isSupportPassKey as isSupportPassKeyUtils } from 'utils'

export const useAppInfoStore = defineStore('appInfoStore', () => {
  const appInfo = ref<ApiResponse.AppInitialData>()
  const showSecurityAgreeDialog = ref(false)
  const isSupportPassKey = ref(false)

  const fetchAppInfo = async () => {
    const res = await AppServices.getAppInitialData()
    appInfo.value = res.data
  }

  const initIsSupportPassKey = async () => {
    isSupportPassKey.value = await isSupportPassKeyUtils()
  }

  onBeforeMount(() => {
    initIsSupportPassKey()
  })

  const needCaptcha = computed(() => {
    return appInfo.value?.commonConfig?.captchaConf?.status === 1
  })

  const defaultArea = computed(() => {
    return `+${appInfo.value?.defaultArea || '86'}`
  })

  const defaultCountryCode = computed(() => {
    return appInfo.value?.countryCode2 || 'CN'
  })

  return {
    appInfo,
    fetchAppInfo,
    needCaptcha,
    showSecurityAgreeDialog,
    isSupportPassKey,
    defaultArea,
    defaultCountryCode,
  }
})
